import React from 'react';

import {PracticeStoreContext} from 'core/stores/RootStore.js';
import {observer} from 'mobx-react';

export default
@observer
class PracticeFAQ extends React.Component {
    static contextType = PracticeStoreContext;

    render() {
        if (!this.context.practiceFAQs?.length) {
            return null;
        }
        return (
            <ol className="answers">
                {this.context.practiceFAQs.map((faq) => {
                    return (
                        <li key={faq.id}>
                            <h2>{faq.question}</h2>
                            <section
                                dangerouslySetInnerHTML={{
                                    __html: faq.answer,
                                }}
                            ></section>
                        </li>
                    );
                })}
            </ol>
        );
    }
}
